<script>
import { shareParkCascade } from "@/api/url";
import { profitInfos, profitRevenueSummary } from "@/api/url";
import * as utils from "@/utils/utils";

export default {
  data() {
    return {
      queryForm: {
        sharedParking: undefined,
        parkingSpace: undefined,
      },
      commonQuery: {
        type: undefined,
        id: undefined,
      },
      profits: undefined,
      profitRevenueSummary: {},
      profitRevenueSummaryTable: [],
      sharedParkingOps: [],
      currentParkingSpaceOps: [],
      loading: false,
      summaryLoading: false,
      revenueDateType: [
        {
          value: 1,
          label: "今日",
        },
        {
          value: 2,
          label: "昨日",
        },
        {
          value: 3,
          label: "上周",
        },
        {
          value: 4,
          label: "上月",
        },
      ],
      currentRevenueType: 1,
      utils,
    };
  },
  methods: {
    handleSharedParkingChange(val) {
      this.queryForm.parkingSpace = undefined;
      const space = this.sharedParkingOps.find((f) => f.value === val);
      if (space) {
        this.currentParkingSpaceOps = space.children;
      }
      this.commonQuery.type = 1;
      this.commonQuery.id = val;
    },
    handleParkingSpaceChange(val) {
      this.commonQuery.type = 2;
      this.commonQuery.id = val;
    },
    async getProfitInfos() {
      this.profitLoading = true;
      let data = await this.$get(profitInfos(), { ...this.commonQuery });
      if (data.status === 200) this.profits = data.data;
    },
    async getRevenueSummary() {
      let data = await this.$get(profitRevenueSummary(), {
        ...this.commonQuery,
        dateType: this.currentRevenueType,
      });
      if (data.status === 200) {
        this.profitRevenueSummary = { ...data.data };
        delete data.data.settlementTime;
        this.profitRevenueSummaryTable = Object.values(data.data);
      }
    },
    async handleDataQuery() {
      this.loading = true;
      await this.getProfitInfos();
      await this.getRevenueSummary();
      this.loading = false;
    },
    async handleRevenueClick(type) {
      this.summaryLoading = true;
      this.currentRevenueType = type;

      await this.getRevenueSummary();
      this.summaryLoading = false;
    },
  },

  async created() {
    console.log("first");
    const data = await this.$get(shareParkCascade());
    if (data.status == 200) {
      this.sharedParkingOps = data.data;
    }
  },
};
</script>

<template>
  <div style="padding: 20px; max-height: 100vh; overflow: hidden;">
    <!-- 顶部停车场选项 -->
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item label="共享停车场" style="width: 350px;">
        <el-select
          v-model="queryForm.sharedParking"
          placeholder="请选择共享停车场"
          style="width: 250px;"
          @change="handleSharedParkingChange"
        >
          <el-option
            v-for="item in sharedParkingOps"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="共享停车位">
        <el-select
          v-model="queryForm.parkingSpace"
          placeholder="请选择共享停车位"
          clearable
          @change="handleParkingSpaceChange"
        >
          <el-option
            v-for="item in currentParkingSpaceOps"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="handleDataQuery"
          >查询</el-button
        >
      </el-form-item>
    </el-form>

    <!-- 内容区域 -->
    <div
      v-if="profits"
      v-loading="loading"
      element-loading-text="数据拼命加载中"
      style="min-height: 80vh; display: flex; flex-direction: column; row-gap: 30px;"
    >
      <!-- 分账汇总区域（总收益、未入账金额等） -->
      <section class="account-content">
        <div class="account balance">
          <img
            src="../../../assets/images/split-account/balance.svg"
            style="color:#10AEFF; width:80px;height:70px;"
          />
          <span>总收益(元)</span>
          <el-divider></el-divider>
          <span>¥{{ profits.totalIncome }}</span>

          <!-- <span class="cash-out" @click="onWithdrawalbtn">去提现</span>-->
        </div>

        <div class="account balance">
          <img
            src="../../../assets/images/split-account/balance.svg"
            style="color:#10AEFF; width:80px;height:70px;"
          />
          <span>可提现金额</span>
          <el-divider></el-divider>
          <div
            style="display: flex; justify-content: center; align-items: center; column-gap: 15px;"
          >
            <span>¥{{ profits.withdrawIncome }}</span>
            <el-button type="text" :disabled="!profits.withdrawabled">
              去提现
            </el-button>
          </div>
        </div>
        <div class="account add">
          <img
            src="../../../assets/images/split-account/add.svg"
            style="color:#10AEFF; width:80px;height:70px;"
          />
          <span>今日新增(元)</span>
          <el-divider></el-divider>
          <span>¥{{ profits.todayIncome }}</span>
        </div>
        <div class="account unposted">
          <img
            src="../../../assets/images/split-account/unposted.svg"
            style="color:#10AEFF; width:80px;height:70px;"
          />
          <span>今日未入账(元)</span>
          <el-divider></el-divider>
          <span>¥{{ profits.unrecorded }}</span>
        </div>
      </section>

      <!-- 营收汇总 -->
      <section>
        <h4>营收汇总</h4>
        <div class="revenue-container">
          <div class="revenue">
            <el-button
              type="text"
              v-for="item of revenueDateType"
              :key="item.value"
              class="revenue-type"
              :class="{ active: currentRevenueType === item.value }"
              @click="handleRevenueClick(item.value)"
              >{{ item.label }}</el-button
            >
          </div>
          <div
            style="padding-top: 10px; font-weight: 600;"
            v-if="profitRevenueSummary.settlementTime"
          >
            缴费时间：{{ profitRevenueSummary.settlementTime.join("——") }}
          </div>
        </div>
        <el-table
          :data="profitRevenueSummaryTable"
          style="width: 100%; margin-top: 20px;"
          v-loading="summaryLoading"
          border
        >
          <el-table-column prop="type" label="业务类型" width="180">
          </el-table-column>
          <el-table-column prop="totalAmount" label="交易总额" width="180">
            <template v-slot="scope">
              {{ utils.getOrDefault(scope.row.totalAmount, "-", "", "元") }}
            </template>
          </el-table-column>
          <el-table-column prop="poundage" label="渠道手续费">
          </el-table-column>
          <el-table-column prop="profit" label="服务分成">
            <template v-slot="scope">
              {{ utils.getOrDefault(scope.row.profit, "-") }}
            </template>
          </el-table-column>
          <el-table-column prop="volumeAmount" label="优惠卷金额">
            <template v-slot="scope">
              {{ utils.getOrDefault(scope.row.volumeAmount, "-", "", "元") }}
            </template>
          </el-table-column>
          <el-table-column prop="settleAmount" label="结算金额">
            <template v-slot="scope">
              {{ utils.getOrDefault(scope.row.settleAmount, "-", "", "元") }}
            </template>
          </el-table-column>
        </el-table>
      </section>
    </div>
    <div
      v-else
      style="display: flex; justify-content: center; align-items: center; height: 100vh; margin-top: -10vh;"
    >
      <el-empty description="请选择先选择共享停车场查询数据"></el-empty>
    </div>
  </div>
</template>

<style scoped>
.account-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.account {
  width: 22%;
  height: 220px;
  text-align: center;
  border: 1px solid #eee;
  border-radius: 10px;
  margin: 0 auto;
  padding: 15px;
  box-sizing: border-box;
}
.account span {
  display: block;
  color: #777;
  font-size: 18px;
  font-weight: bold;
  padding: 5px 0;
  box-sizing: border-box;
}

span.cash-out {
  width: 150px;
  height: 30px;
  background: #188fff;
  color: white;
  margin: 0 auto;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
}

.revenue-container {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}
.revenue-container::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: #e4e7ed;
}

.revenue {
  display: flex;
  column-gap: 35px;
  margin-top: 10px;
  width: 42%;
}

.revenue-type {
  position: relative;
  color: black;
}
.revenue-type.active {
  color: #188fff;
}
.revenue-type.active::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 2px;
  background-color: #188fff;
  z-index: 999;
}
</style>
